import React, { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "../common/Reveal";
import "./Experience.css";

export function Experience() {
  const { t } = useLanguage();
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 0.75", "end 0.6"],
  });

  return (
    <section id="experience" className="section experience">
      <div className="container section-inner">
        <Reveal direction="up">
          <span className="eyebrow">{t.experience.eyebrow}</span>
          <h2 className="section-heading">{t.experience.heading}</h2>
          <p className="section-sub">{t.experience.subheading}</p>
        </Reveal>

        <div className="timeline" ref={containerRef}>
          <div className="timeline__track" />
          <motion.div className="timeline__progress" style={{ scaleY: scrollYProgress }} />

          {t.experience.items.map((exp, i) => (
            <Reveal direction="up" delay={0.05 * i} key={exp.id} className="timeline__item">
              <span className="timeline__dot" />
              <div className="timeline__card">
                <div className="timeline__card-head">
                  <div>
                    <h3 className="timeline__role">{exp.role}</h3>
                    <span className="timeline__org">{exp.org}</span>
                  </div>
                  <span className="timeline__period mono">{exp.period}</span>
                </div>
                <p className="timeline__desc">{exp.description}</p>
                <ul className="timeline__points">
                  {exp.points.map((point, pi) => (
                    <li key={pi}>{point}</li>
                  ))}
                </ul>
                <div className="timeline__stack">
                  {exp.stack.map((tech) => (
                    <span className="tag" key={tech}>
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal direction="up" className="timeline__item timeline__item--placeholder">
            <span className="timeline__dot timeline__dot--muted" />
            <p className="timeline__placeholder-text">{t.experience.placeholder}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
